import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-amenities',
  templateUrl: './amenities.component.html',
  styleUrls: ['./amenities.component.css']
})
export class AmenitiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.scroll(0, -window.scrollY);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/amenities/amenities.component.ts